
// Codekit -->
// @codekit-prepend "components/loadIn.js"
// @codekit-prepend "components/rhBanner.js"
// @codekit-prepend "components/rhParallax.js"
// @codekit-prepend "components/rhImagePop.js"
// @codekit-prepend "components/rhLazy.js"
// @codekit-prepend "components/share.js"
// @codekit-prepend "components/contentBuilder.js"
// @codekit-prepend "components/video.js"
// @codekit-prepend "components/image-gallery.js"


	//SELECTORS
	var $body = $('body'),
	currpage = $body.attr('data-page'),
	site = $body.attr('data-site'),
	device = $body.attr('data-device'),
	$this,
	height = $(window).height(),
	width = $(window).width(),
	headerType = $body.attr('data-headerType');

/*
	height = $(window).height(),
	width = $(window).width();
*/

	//JQUERY DATA

	//IMAGES LOADED
/*
	$body.imagesLoaded(function(){


	});


*/

/* ==========================================================================
  DOC READY
  ========================================================================== */

	//ON READY
	$(document).ready(function(){
		
		$body.rhLoadIn();			
				
		$body.rhLazy({
			scrollThreshold:100
		});

		$('.parallax').rhBanner({
			parallaxRatio:1.2
		});	
						
		$('.zoom').rhImagePop({
			gutter:30
		});	

        $('body').imagesLoaded({},function(){
            $('.parallax-element').rhParallax();
        });


		$('#heroImage').imagesLoaded({background:true},function(){
		
			$('#heroHiRes').animate({"opacity":1}, 300, function() {
		    	$('#heroLoRes').remove();
		  	});
			
		});
		
		$('.js-scroll-button').on('click', function(e){
			e.preventDefault(); 
			
			$(window).scrollTo( height, 600, {axis:'y'} );
		});	
		
		
		
	var $fullHeight = $('.fullHeight');

    $fullHeight.css({"height":height + "px"});



	}); // END ON READY





/* ==========================================================================
   MENU
  ========================================================================== */


	var $menuButton = $('#menuButton'),
		$menuWrapper= $('#menuWrapper'),
		$menuButtonText = $('#menuButtonText'),
		menuOpen = false;
		
	$(window).on('scroll',uiColor);



	$menuButton.on('click', function(e){
		e.preventDefault();

		$this = $(this);
		$this.addClass('working');

		menuOpen = !menuOpen;

		if(menuOpen) {
			// open mmenu
			$body.addClass('stopScrolling light');
			$this.addClass('active');
			$menuButtonText.text('Close');
			$menuWrapper.fadeIn(200);
			setTimeout(function(){
				$('.x').addClass('rotate45');
				$('.y').addClass('rotate135');
			}, 120);

		}
		else {
			// close mmenu
			$body.removeClass('stopScrolling');
			if (headerType != 'light') {
				$body.removeClass('light');
			} 
			
			$menuWrapper.fadeOut(200);
			$menuButtonText.text('Menu');
			$('.x').removeClass('rotate45');
			$('.y').removeClass('rotate135');
			$this.removeClass('active');

		}
		
		setTimeout(function(){
			$this.removeClass('working');
		}, 300);


	});

	if (device == 'desktop') {

		var $menuLink = $('.menuLink'),
			$menuBackground = $('#menuBackground'),
			thisCount;
		
			$menuLink.hover( 
				function() {
					$this = $(this);
					thisCount = $this.data('count');

					$menuLink.addClass('hide');
					$this.removeClass('hide');
					$menuBackground.addClass('active');
					$menuBackground.find('li').eq(thisCount).addClass('active');

				}, function() {
					$menuLink.removeClass('hide');
					$menuBackground.removeClass('active');
					$menuBackground.find('li').removeClass('active');
				}
			);

		}


		function uiColor() {
			var st = $(this).scrollTop();
			
			if (headerType == 'light') {
				
				if (st>height) {
					$body.removeClass('light');
				} else {
					$body.addClass('light');
				}

			} 
			
		}




/* ==========================================================================
   HOMEPAGE
  ========================================================================== */

	if (currpage == 'homepage') {



/*

		var $homepageHeroPrimary = $('#homepageHeroPrimary'),
			$homepageHeroSecondary = $('#homepageHeroSecondary');

		$('.tickerWrapper').ticker();


		if ( width > 768 ) {

			slidePlay();

		} else {
			slidePlayMobile();
		}


		homepageSizing();



		$(window).resize(function() {

			homepageSizing();
		});
*/



	}


/*
function homepageSizing() {

	height = $(window).height();
	width = $(window).width();

	if (width < 768) {

		$homepageHeroPrimary.css({"height":height+"px"});
		$homepageHeroSecondary.css({"height":height+"px"});

	} else {

		$homepageHeroPrimary.css({"height":(width/2)+"px"});
		$homepageHeroSecondary.css({"height":(width/2)+"px"});


	}


}
*/




/* ==========================================================================
   CLIENTS
  ========================================================================== */

/*
	if (currpage == 'clients') {

		var $clientsPageBG = $('#clientsPageBG'),
			$clientsBackground = $('#clientsBackground'),
			$clientsBackgroundImage = $clientsBackground.find('li'),
			$clientButton = $('#clientsListInner').find('a.clientButton'),
			$clientsListOuter = $('#clientsListOuter'),
			$clientAjaxHolder = $('#clientAjaxHolder'),
			$clientOverlay = $('#clientOverlay'),
			thisCount,
			loadURL;


		$clientsPageBG.waitForImages(function() {

		   	$clientsPageBG.animate({"opacity":"0.2"}, 400);

		});

		$clientsBackgroundImage.waitForImages(function() {

		   	$clientsListOuter.animate({"opacity":"1"}, 400);

		});


		if (device == 'desktop') {

			$clientButton.hover(
				function() {

					$this = $(this);
					thisCount = $this.data('count');

					$clientButton.addClass('hide');
					$this.removeClass('hide');
					$clientsBackground.addClass('active');
					$clientsBackgroundImage.eq(thisCount).addClass('active');

				}, function() {
					$clientButton.removeClass('hide');
					$clientsBackground.removeClass('active');
					$clientsBackgroundImage.removeClass('active');
				}
			);

		}



		$clientButton.on('click', function(e){
			e.preventDefault();

			$body.addClass('stop-scrolling');

			loadURL = $(this).attr('href');

			$clientOverlay.fadeIn(100);

			$clientAjaxHolder.load( loadURL + " #clientAjaxWrapper", function() {
				$('#clientLoading').fadeOut(100);
				$('#closeClientOverlay').fadeIn(100);
				loadCarousel();
			});


		});

		$body.on('click', '#closeClientOverlay', function(e){
			e.preventDefault();

				$body.removeClass('stop-scrolling');

			$clientOverlay.fadeOut( 100,function() {
				$clientAjaxHolder.empty();
				$('#clientLoading').show();
  			});


		});





	}
*/



/* ==========================================================================
   SINGLE CLIENTS
  ========================================================================== */

/*

	if (currpage == 'singleClient') {

		loadCarousel();


	}
*/





/* ==========================================================================
   SERVICES
  ========================================================================== */




		var $serviceTitle = $('.serviceTitle'),
			$thisParent;

		$serviceTitle.on('click', function(e){
			e.preventDefault();

			$this = $(this);
			$thisParent = $this.parent().parent();
			$thisParent.toggleClass('active');

/*
			if ($thisParent.hasClass('active')) {

				$thisParent.animate({
				    height: $thisParent.get(0).scrollHeight
				}, 300, function(){
				    $thisParent.height('auto');
				});

			} else {

				$thisParent.animate({height: '60px'}, 300);

			}
*/


		});



	/* ==========================================================================
		Load More Journal
		========================================================================== */


	var $loadMoreJournal = $('#loadMoreJournal');

	$loadMoreJournal.on('click', function(e){
		e.preventDefault();
		$loadMoreJournal.addClass('working');
		loadJournal();
	});


function loadJournal() {

	var $loadingJournal = $('#loadingJournal'),
		$noMoreJournal = $('#noMoreJournal'),
		$loadingBay = $('#loadingBay'),
		totalPages, loadUrl, nextPage, nextURL, $elements;

	$body.addClass('working');
		loadUrl = $loadMoreJournal.attr('href');
		totalPages = $loadMoreJournal.data('total');
		nextPage = $loadMoreJournal.data('next');
		$loadingJournal.show();

	if (nextPage <= totalPages) {

		$loadingBay.load(loadUrl + " #ajaxHolder", function() {
			$elements = $loadingBay.find('.card');
			$('#ajaxHolder').append($elements);
			
			$body.rhLazy();
			$body.rhLoadIn();


			nextPage++;

			$loadMoreJournal.data('next', nextPage);

			if (nextPage > totalPages) {
					$loadMoreJournal.hide();
					$noMoreJournal.show();
					$loadingJournal.hide();
			}

			nextURL = site + '/journal/page/' + nextPage;
			$loadMoreJournal.attr('href', nextURL);


			if (location.href != loadUrl) {
				history.pushState({}, '', loadUrl);
			}

			$loadingBay.empty();
			$body.removeClass('working');
			$loadingJournal.hide();
			$loadMoreJournal.removeClass('working');

		});

	}

}


/* ==========================================================================
	FUNCTIONS
	========================================================================== */


/*


function slidePlay() {

	var $marque = $('#marque'),
		$slide1 = $('#slide1'),
		$slide2 = $('#slide2'),
		$slide3 = $('#slide3'),
		$video1 = $('#video1'),
		$video2 = $('#video2');


	var tl = new TimelineMax({onComplete:goAgain});


	tl.set($slide1, {className:"+=active"})

		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1})
		.to($marque, 0.7, { ease: Power4.easeInOut, rotation:90, transformOrigin:"center center"} , "+=4")


		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'hidden', opacity: 0}, "-=0.5")
		.to($slide2, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1}, "-=0.5")

		.add( function(){ $video1.get(0).play(); }, "-=0.3")
		.to($marque, 0.7, { ease: Power4.easeInOut, rotation:0, transformOrigin:"center center"} , "+=4")
		.add( function(){ $video1.get(0).pause(); } )

		.to($slide2, 0.3, { ease: Power4.easeInOut, visibility: 'hidden', opacity: 0}, "-=0.5")
		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1}, "-=0.5")

		.to($marque, 0.7, { ease: Power4.easeInOut, rotation:-90, transformOrigin:"center center"} , "+=4")

		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'hidden', opacity: 0}, "-=0.5")
		.to($slide3, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1}, "-=0.5")

		.add( function(){ $video2.get(0).play(); }, "-=0.3")
		.to($marque, 0.7, { ease: Power4.easeInOut, rotation:0, transformOrigin:"center center"} , "+=4")
		.add( function(){ $video2.get(0).pause(); } )

		.to($slide3, 0.3, { ease: Power4.easeInOut, visibility: 'hidden', opacity: 0}, "-=0.5")
		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1}, "-=0.5")

		function goAgain() {
			slidePlay();
		}

}
*/



/*


function slidePlayMobile() {

	var $marque = $('#marque'),
		$slide1 = $('#slide1'),
		$slide2 = $('#slide2'),
		$slide3 = $('#slide3'),
		$headerLogo = $('#headerLogo'),
		$menuDiv = $menuButton.find('div');


	var tl = new TimelineMax({onComplete:goAgain});


	tl.set($slide1, {className:"+=active"})

		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1})
		.to($marque, 0.7, { ease: Power4.easeInOut, rotation:90, transformOrigin:"center center"} , "+=4")
		.to($('#marque svg .color'), 0.7, { ease: Power4.easeInOut, fill: '#e8e8e8'}, "-=0.7")

		.to($headerLogo, 0.7, {ease: Power4.easeInOut, color: '#ffffff'}, "-=0.7")
		.to($menuDiv, 0.7, { ease: Power4.easeInOut, backgroundColor: '#ffffff'}, "-=0.7")

		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'hidden', opacity: 0}, "-=0.5")
		.to($slide2, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1}, "-=0.5")

		.to($marque, 0.7, { ease: Power4.easeInOut, rotation:0, transformOrigin:"center center"} , "+=4")

		.to($('#marque svg .color'), 0.7, { ease: Power4.easeInOut, fill: '#1d1d1b'}, "-=0.7")
		.to($headerLogo, 0.7, { ease: Power4.easeInOut, color: '#000000'}, "-=0.7")
		.to($menuDiv, 0.7, { ease: Power4.easeInOut, backgroundColor: '#000000'}, "-=0.7")

		.to($slide2, 0.3, { ease: Power4.easeInOut, visibility: 'hidden', opacity: 0}, "-=0.5")
		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1}, "-=0.5")

		.to($marque, 0.7, { ease: Power4.easeInOut, rotation:-90, transformOrigin:"center center"} , "+=4")
		.to($('#marque svg .color'), 0.7, { ease: Power4.easeInOut, fill: '#e8e8e8'}, "-=0.7")
		.to($headerLogo, 0.7, { ease: Power4.easeInOut, color: '#ffffff'}, "-=0.7")
		.to($menuDiv, 0.7, { ease: Power4.easeInOut, backgroundColor: '#ffffff'}, "-=0.7")

		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'hidden', opacity: 0}, "-=0.5")
		.to($slide3, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1}, "-=0.5")

		.to($marque, 0.7, { ease: Power4.easeInOut, rotation:0, transformOrigin:"center center"} , "+=4")

		.to($('#marque svg .color'), 0.7, { ease: Power4.easeInOut, fill: '#1d1d1b'}, "-=0.7")
		.to($headerLogo, 0.7, { ease: Power4.easeInOut, color: '#000000'}, "-=0.7")
		.to($menuDiv, 0.7, { ease: Power4.easeInOut, backgroundColor: '#000000'}, "-=0.7")

		.to($slide3, 0.3, { ease: Power4.easeInOut, visibility: 'hidden', opacity: 0}, "-=0.5")
		.to($slide1, 0.3, { ease: Power4.easeInOut, visibility: 'visible', opacity: 1}, "-=0.5")

		function goAgain() {
			slidePlayMobile();
		}

}
*/




/*


function sizes(){

    for (i =0; i<size; i++){
        loadMatrix[i] = loadMatrix[i] || { el: loadElements[i] }
		loadRect = loadMatrix[i].el.getBoundingClientRect();
		loadMatrix[i].start = loadRect.top + window.pageYOffset + scrollThreshold;
    }
    loadIn();

}

function loadIn() {
	st = $(this).scrollTop();
	viewportBottom = st + height;

		for( i=0; i<size; i++ ) {

		    if (loadMatrix[i].start < viewportBottom) {

			    thisElement = $(loadMatrix[i].el);
			    thisElement.addClass('isVisible');

		 	}
		}
}
*/



/*

function loadCarousel() {

	var $clientImageCarousel = $('#clientImageCarousel'),

	carouselOptions = {
			cellAlign: 'center',
			contain: true,
			pageDots: true,
			prevNextButtons: false,
			wrapAround:true,
			cellSelector:'.clientImageCarouselImg',
			imagesLoaded: true
		};

		$clientImageCarousel.on( 'ready.flickity', function() {
			$clientImageCarousel.animate({"opacity":"1"}, 300);
		});

		$clientImageCarousel.flickity( carouselOptions );

}


$('.videoPlaceHolder').click( function(e) {
	e.preventDefault();

	var videoSource = $(this).data('src'),
		$this = $(this);

	$this.next('iframe').attr('src', videoSource);

	$this.fadeOut();

});
*/





/* ==========================================================================
	RESIZE EVENTS
	========================================================================== */

$(window).resize(function() {
/*

    height = $(window).height();
    width = $(window).width();

*/






});
